module.exports = __webpack_public_path__ + "img/account_mb_05.f9debb3d.jpg";